import { createAsyncMessageBundleManager, LocalizationContextBuilder, MessageBundle } from '@amzn/arb-tools';
import arbManifest from '../../build/private/i18n/arbManifest';
import en from '../../build/private/i18n/translation-en.json';

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_LC_BUILDER = new LocalizationContextBuilder().withDefaultLocale(
  DEFAULT_LOCALE
);

const localizationContextProvider = (forcedLocale?: string) => {

  const langTag = document.documentElement.lang;
  const navigatorLanguage = navigator.language;

  return DEFAULT_LC_BUILDER.withLocale(
    forcedLocale ?? (langTag || navigatorLanguage || DEFAULT_LOCALE)
  ).build();
};

let resolveBundleUrl: ((x: string | undefined) => string | undefined) | undefined = undefined;
let resolveResourcePack: ((url: string) => Promise<any>) | undefined = undefined;

if (['localhost', '0.0.0.0', '127.0.0.1'].includes(window.location.hostname)) {
  // if running locally or testing just use english strings
  resolveResourcePack = async () => en;
} else {
  resolveBundleUrl = (url?: string) => url ? `https://d2ztvpy7vt83fw.cloudfront.net/trim/i18n/${url}` : undefined;
}

let trimStringBundle: MessageBundle;

export const getTrimBundle = async (): Promise<void> => {
  const mbm = createAsyncMessageBundleManager({
    arbManifest,
    localizationContextProvider,
    resolveBundleUrl,
    resolveResourcePack,
  });

  trimStringBundle = await mbm.getBundle('brTrim');
};

export const translate = (messageKey: string, args?: Record<string, unknown>): string => {
  if (!trimStringBundle) return messageKey;

  try {
    return trimStringBundle.formatMessage(messageKey, args ?? {});
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`Unable to find string: ${messageKey}`);
    return messageKey;
  }
};

export const translateFooter = async (stringId: string): Promise<string> => {
  if (!trimStringBundle) {
    const mbm = createAsyncMessageBundleManager({
      arbManifest,
      localizationContextProvider,
      resolveBundleUrl,
      resolveResourcePack,
    });

    const bundle = await mbm.getBundle('brTrim');

    try {
      return bundle.getMessage(stringId);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(`Unable to find string: ${stringId}`);
      return stringId;
    }
  } else {
    // if the bundle already exists use translate function
    return translate(stringId);
  }
};
